import resume from "../assets/pdf/Lino_Silva_-_Resume.pdf";
import image from "../assets/jpeg/profile.jpeg";

export const headerData = {
  name: "Lino Silva",
  title: "",
  description:
    "I'm an Engineer and tinkerer at heart, with over 15 years of experience on the tech / e-commerce / fashion / luxury / retail / crypto market.",
  description2:
    "Currently self-employed and not actively looking for new opportunities, but always open to connect with like-minded professionals.",
  image: image,
  resumePdf: resume,
};
